export const ThumbDownIcon = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M17 13V4.99999C17 4.73478 17.1054 4.48042 17.2929 4.29289C17.4804 4.10535 17.7348 3.99999 18 3.99999H20C20.2652 3.99999 20.5196 4.10535 20.7071 4.29289C20.8946 4.48042 21 4.73478 21 4.99999V12C21 12.2652 20.8946 12.5196 20.7071 12.7071C20.5196 12.8946 20.2652 13 20 13H17ZM17 13C15.9391 13 14.9217 13.4214 14.1716 14.1716C13.4214 14.9217 13 15.9391 13 17V18C13 18.5304 12.7893 19.0391 12.4142 19.4142C12.0391 19.7893 11.5304 20 11 20C10.4696 20 9.96086 19.7893 9.58579 19.4142C9.21071 19.0391 9 18.5304 9 18V13H6C5.46957 13 4.96086 12.7893 4.58579 12.4142C4.21071 12.0391 4 11.5304 4 11L5 5.99999C5.14382 5.38652 5.41663 4.85975 5.77735 4.49903C6.13807 4.13831 6.56716 3.96317 7 3.99999H14C14.7956 3.99999 15.5587 4.31606 16.1213 4.87867C16.6839 5.44128 17 6.20434 17 6.99999'
        stroke='#002652'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}

export const ThumbUpIcon = ({ size = 20, cl='#0057B8' , ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M7 11V19C7 19.2652 6.89464 19.5196 6.70711 19.7071C6.51957 19.8946 6.26522 20 6 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V12C3 11.7348 3.10536 11.4804 3.29289 11.2929C3.48043 11.1054 3.73478 11 4 11H7C8.06087 11 9.07828 10.5786 9.82843 9.82843C10.5786 9.07828 11 8.06087 11 7V6C11 5.46957 11.2107 4.96086 11.5858 4.58579C11.9609 4.21071 12.4696 4 13 4C13.5304 4 14.0391 4.21071 14.4142 4.58579C14.7893 4.96086 15 5.46957 15 6V11H18C18.5304 11 19.0391 11.2107 19.4142 11.5858C19.7893 11.9609 20 12.4696 20 13L19 18C18.8562 18.6135 18.5834 19.1402 18.2227 19.501C17.8619 19.8617 17.4328 20.0368 17 20H10C9.20435 20 8.44129 19.6839 7.87868 19.1213C7.31607 18.5587 7 17.7956 7 17'
        fill={cl}
      />
      <path
        d='M7 11V19C7 19.2652 6.89464 19.5196 6.70711 19.7071C6.51957 19.8946 6.26522 20 6 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V12C3 11.7348 3.10536 11.4804 3.29289 11.2929C3.48043 11.1054 3.73478 11 4 11H7ZM7 11C8.06087 11 9.07828 10.5786 9.82843 9.82843C10.5786 9.07828 11 8.06087 11 7V6C11 5.46957 11.2107 4.96086 11.5858 4.58579C11.9609 4.21071 12.4696 4 13 4C13.5304 4 14.0391 4.21071 14.4142 4.58579C14.7893 4.96086 15 5.46957 15 6V11H18C18.5304 11 19.0391 11.2107 19.4142 11.5858C19.7893 11.9609 20 12.4696 20 13L19 18C18.8562 18.6135 18.5834 19.1402 18.2227 19.501C17.8619 19.8617 17.4328 20.0368 17 20H10C9.20435 20 8.44129 19.6839 7.87868 19.1213C7.31607 18.5587 7 17.7956 7 17'
        stroke='#002652'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}

export const FeedbackFillIcon = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 29 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M8.69819 24.6726C8.31218 24.9337 7.83022 25.0453 7.35579 24.9832C6.88135 24.9212 6.45228 24.6906 6.16069 24.3409C5.9274 24.0579 5.80078 23.7127 5.8 23.3575V19.7374H4.7125C2.10975 19.7374 0 17.8223 0 15.4606V4.27683C0 1.91507 2.10975 0 4.7125 0H24.2875C26.8902 0 29 1.91507 29 4.27683V15.4606C29 17.824 26.8902 19.7374 24.2875 19.7374H15.9681L8.69819 24.6726Z'
        fill='black'
      />
    </svg>
  )
}

export const FeedbackIcon = ({ size = 20, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 29 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M4.71289 0.5H24.2871C26.6603 0.5 28.4997 2.23546 28.5 4.27637V15.4609C28.4998 17.5034 26.6604 19.2373 24.2871 19.2373H15.8145L15.6875 19.3232L8.41699 24.2588C8.13528 24.449 7.77732 24.5338 7.4209 24.4873C7.10884 24.4465 6.83008 24.3099 6.62695 24.1104L6.54492 24.0205C6.38378 23.824 6.30032 23.591 6.2998 23.3564V19.2373H4.71289C2.3397 19.2373 0.500212 17.5019 0.5 15.4609V4.27637C0.500268 2.29936 2.226 0.608789 4.49121 0.504883L4.71289 0.5Z'
        fill='white'
        stroke='black'
      />
    </svg>
  )
}
